import apiClient from "../services/api";

// Open an auth-protected PDF without tripping popup blockers: the tab is opened synchronously
// inside the click (keeps user activation), then pointed at the blob once the download finishes.
// Large PDFs (I-9, W-4, WH-347) used to take long enough that a window.open() after `await`
// was silently blocked.
export async function openAuthenticatedPdf(path, { filename = "document.pdf", params } = {}) {
  const tab = window.open("", "_blank");
  if (tab) {
    tab.document.title = "Loading PDF…";
    tab.document.body.innerHTML =
      '<p style="font:16px system-ui;color:#555;padding:24px">Loading PDF… this can take a few seconds.</p>';
  }
  try {
    const res = await apiClient.get(path, { responseType: "blob", params });
    const blob = res.data.type ? res.data : new Blob([res.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    if (tab && !tab.closed) {
      tab.location.replace(url);
    } else {
      // Popup blocked / standalone PWA: fall back to a download the user can open.
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
    setTimeout(() => URL.revokeObjectURL(url), 120000);
    return true;
  } catch (err) {
    if (tab && !tab.closed) tab.close();
    throw err;
  }
}
